<footer>
  <small>{{ footerVersion }}</small>
  <small>
    &copy; Copyright {{ footerYear }}, FLYHT Aerospace Solutions Ltd.
  </small>
</footer>
